import { atom } from "jotai";

export const unifiedSearchQueryAtom = atom<string>("");
